// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as ErrorUtils$OrcaPaymentPage from "../Utilities/ErrorUtils.bs.js";
import * as PaymentEventData$OrcaPaymentPage from "../../shared-code/sdk-utils/events/PaymentEventData.bs.js";
import * as PaymentEventTypes$OrcaPaymentPage from "../../shared-code/sdk-utils/events/PaymentEventTypes.bs.js";

var validSubscriptionEvents = ["surchargeInfo"];

function stringToEvent(str, key) {
  if (str === "surchargeInfo") {
    return "Surcharge";
  }
  ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(str, validSubscriptionEvents, key);
  return "UnknownEvent";
}

function getSubscriptionEvents(dict, key) {
  var context = "options." + key;
  var subscriptionList = Core__Option.getOr(Core__Option.flatMap(dict[key], Core__JSON.Decode.array), []);
  var mappedSubscriptionEvents = subscriptionList.map(function (item) {
          var str = Core__JSON.Decode.string(item);
          if (str !== undefined) {
            return stringToEvent(str, context);
          } else {
            ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(JSON.stringify(item), validSubscriptionEvents, context);
            return "UnknownEvent";
          }
        }).filter(function (opt) {
        return opt !== "UnknownEvent";
      });
  if (mappedSubscriptionEvents.length === 0) {
    return ;
  } else {
    return mappedSubscriptionEvents;
  }
}

function createCardInfoPayload(cardInfo) {
  var payload = PaymentEventData$OrcaPaymentPage.cardInfoToJson(cardInfo);
  return [
          [
            "elementType",
            "payment"
          ],
          [
            "eventName",
            PaymentEventTypes$OrcaPaymentPage.eventToString("PaymentMethodInfoCard")
          ],
          [
            "payload",
            payload
          ]
        ];
}

function createFormStatusPayload(status) {
  var payload = PaymentEventData$OrcaPaymentPage.formStatusEventToJson(status);
  return [
          [
            "elementType",
            "payment"
          ],
          [
            "eventName",
            PaymentEventTypes$OrcaPaymentPage.eventToString("FormStatus")
          ],
          [
            "payload",
            payload
          ]
        ];
}

function createPaymentMethodStatusPayload(paymentMethod, paymentMethodType, isSavedPaymentMethod, isOneClickWalletOpt) {
  var isOneClickWallet = isOneClickWalletOpt !== undefined ? isOneClickWalletOpt : false;
  var payload = PaymentEventData$OrcaPaymentPage.paymentMethodStatusEventToJson(paymentMethod, paymentMethodType, isSavedPaymentMethod, isOneClickWallet);
  return [
          [
            "elementType",
            "payment"
          ],
          [
            "eventName",
            PaymentEventTypes$OrcaPaymentPage.eventToString("PaymentMethodStatus")
          ],
          [
            "payload",
            payload
          ]
        ];
}

function createBillingAddressPayload(country, state, postalCode) {
  var payload = PaymentEventData$OrcaPaymentPage.paymentMethodInfoAddressToJson(country, state, postalCode);
  return [
          [
            "elementType",
            "payment"
          ],
          [
            "eventName",
            PaymentEventTypes$OrcaPaymentPage.eventToString("PaymentMethodInfoBillingAddress")
          ],
          [
            "payload",
            payload
          ]
        ];
}

function createCvcStatusPayload(iframeId, isCvcEmpty, isCvcComplete) {
  var $$event = PaymentEventData$OrcaPaymentPage.buildCvcStatusEvent(undefined, undefined, isCvcEmpty, isCvcComplete);
  var payload = PaymentEventData$OrcaPaymentPage.cvcStatusEventToJson($$event);
  return [
          [
            "elementType",
            "cardCvc"
          ],
          [
            "iframeId",
            iframeId
          ],
          [
            "eventName",
            PaymentEventTypes$OrcaPaymentPage.eventToString("CvcStatus")
          ],
          [
            "payload",
            payload
          ]
        ];
}

function createSurchargePayload(surchargeDetails) {
  var $$event = surchargeDetails !== undefined ? PaymentEventData$OrcaPaymentPage.buildSurchargeEvent({
          type: surchargeDetails.surcharge.type,
          value: surchargeDetails.surcharge.value
        }, Caml_option.some(surchargeDetails.taxOnSurcharge), surchargeDetails.displaySurchargeAmount, surchargeDetails.displayTaxOnSurchargeAmount, surchargeDetails.displayTotalSurchargeAmount) : PaymentEventData$OrcaPaymentPage.buildSurchargeEvent({
          type: "",
          value: 0.0
        }, undefined, undefined, undefined, undefined);
  var payload = PaymentEventData$OrcaPaymentPage.surchargeEventToJson($$event);
  return [
          [
            "elementType",
            "payment"
          ],
          [
            "eventName",
            "surchargeInfo"
          ],
          [
            "payload",
            payload
          ]
        ];
}

export {
  validSubscriptionEvents ,
  stringToEvent ,
  getSubscriptionEvents ,
  createCardInfoPayload ,
  createFormStatusPayload ,
  createPaymentMethodStatusPayload ,
  createBillingAddressPayload ,
  createCvcStatusPayload ,
  createSurchargePayload ,
}
/* No side effect */
